export const BRAND_ID = 'C357FBA3-F2B4-4173-B800-BA45711DA8ED';

